import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-full-review',
  templateUrl: './full-review.component.html',
  styleUrls: ['./full-review.component.css']
})
export class FullReviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/components/full-review/full-review.component.ts